<template>
    <div>
        <div class="container-fluid banner dark d-flex justify-content-center align-items-center">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h1>404 Error: '{{ path }}' is not a known path.</h1>
                </div>
            </div>
            <div class="gradient"></div>
            <div class="bg-img">
                <img src="../../src/assets/img/bg_footer.jpg" />
            </div>
        </div>

        <div class="light">
            <div class="container">
                <div class="row section d-flex justify-content-center align-items-center">
                    <div class="col-lg-12 text-center">
                        <!-- <img class="pd-logo" src="../../src/assets/img/logo_pddigital_large.png" /> -->
                    </div>

                    <div class="col-lg-6 text-center">
                        <h2>404 Error: '{{ path }}' is not a known path.</h2>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid ft">
            <siteFooter></siteFooter>
        </div>
   </div>
</template>
<script>
    import siteFooter from '../../src/pages/components/siteFooter';

    export default {
        props: ['path'],
        components: {
            siteFooter
        }
    };
</script>
